import { css } from 'styled-jsx/css';

export default css`
  .tabs {
    display: flex;
    // flex-wrap: wrap; // fixed the problem of text extending beyond the cell borders
    margin-bottom: 12px;
  }

  .tab {
    flex: 1 1 20%;
    // max-width: 20%; // fixed the problem of text extending beyond the cell borders
    min-width: unset;
    background-color: transparent;
    padding: 6px; // fixed the problem of text extending beyond the cell borders
    border: 1px solid #949494;
    color: #949494;
    font-family: 'Roboto-Medium';
    font-size: 13px;
    letter-spacing: 0;
    line-height: 20px;
    text-align: center;
  }

  .tab:first-child {
    border-left-width: 1px;
    border-radius: 2px 0 0 2px;
  }

  .tab:last-child {
    border-radius: 0 2px 2px 0;
  }

  .selected-tab {
    background-color: #950810;
    color: #e4e4e4;
    border-color: #242424;
  }

  @media (max-width: 1250px) {
    .tab {
      flex: 1 1 50%;
      max-width: 50%;
    }
  }

  @media (max-width: 992px) {
    .tab {
      flex: 1 1 30%;
      max-width: 30%;
    }
  }

  @media (max-width: 600px) {
    .tabs {
      flex-wrap: wrap;
    }
    .tab {
      flex: 1 1 50%;
      max-width: 50%;
    }
  }

  @media (max-width: 400px) {
    .tab {
      flex: 1 1 100%;
      max-width: 100%;
    }
  }
`;
